import { render, staticRenderFns } from "./ConfirmEmailDialog.vue?vue&type=template&id=1472b8e6&scoped=true&"
import script from "./ConfirmEmailDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailDialog.vue?vue&type=style&index=0&id=1472b8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472b8e6",
  null
  
)

export default component.exports